import { render, staticRenderFns } from "./TargetEdit.vue?vue&type=template&id=2f2eb2b8&"
import script from "./TargetEdit.vue?vue&type=script&lang=js&"
export * from "./TargetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports